export default "/images/vendor/flag-icon-css/flags/4x3/al.svg?a6a6e8ad28b3af63bd4e86ff93386fa1";